import React from 'react';
import ApolloClient from 'apollo-boost';
import { ApolloProvider } from '@apollo/react-hooks';
import Layout from '../../../components/layout';
import SEO from '../../../components/seo';
import { SettingProvider } from '../../../lib/context/settings';
import { AdsProvider } from '../../../lib/context/ads';
import { Col, Row } from 'antd';
import { device } from '../../../lib/theme';
import styled from 'styled-components';
import { Title, BulletList } from '../../../components/styles';
import CarCareLocationBox from '../../../components/widgets/sidebar/carcare-location-box';

const client = new ApolloClient<any>({
  uri: `https://${process.env.GATSBY_WORDPRESS_URL_PATH}/graphql`,
  fetchOptions: {
    credentials: 'include',
  },
});

const HeroContainer = styled(Row)`
  background-image: url('https://aaacdndev.blob.core.windows.net/wordpress/2021/02/Header_Image.jpg');
  background-size: cover;
  background-position: right;
  background-repeat: no-repeat;
  height: 340px;

  h1 {
    max-width: 80%;
    font-size: 32px;
    line-height: 1.1;
  }

  @media ${device.laptop} {
    h1 {
      max-width: 60%;
      font-size: 56px;
      line-height: 1.2;
    }

    background-position: center center;
  }
`;

const AlbemarleLandingPage: React.FC<any> = () => {
  return (
    <ApolloProvider client={client as any}>
      <SettingProvider>
        <AdsProvider>
          <Layout key={`${typeof window}`}>
            <SEO
              title="AAA Car Care Albemarle | We Are Moving!"
              image="https://aaacdndev.blob.core.windows.net/wordpress/2021/02/Header_Image.jpg"
              canonicalUrl="/automotive/carcar/albemarle"
            />
            <HeroContainer align="middle">
              <Col xs={{ span: 22, offset: 1 }} md={{ span: 20, offset: 2 }}>
                <Title
                  white
                  style={{
                    margin: 'auto',
                    padding: '5px',
                    textAlign: 'center',
                  }}
                >
                  <span style={{ backgroundColor: 'red', padding: '5px 15px' }}>
                    We&apos;re moving!
                  </span>
                </Title>
                <h2
                  style={{
                    color: 'white',
                    textAlign: 'center',
                    marginTop: '16px',
                  }}
                >
                  Our AAA Albemarle Car Care location at 5617 Albemarle Rd,
                  Charlotte, NC 28212, will be moving on March 19th, 2021.
                </h2>
              </Col>
            </HeroContainer>
            <Row style={{ paddingTop: 48, paddingBottom: 48 }}>
              <Col
                xs={{ span: 22, offset: 1 }}
                md={{ span: 10, offset: 2 }}
                lg={{ span: 12, offset: 2 }}
              >
                <h1 style={{ fontFamily: `'CG-bold', sans-serif` }}>
                  Thank you for being a customer of AAA Car Care.
                </h1>
                <p>
                  As the Assistant Vice President, I appreciate you trusting us
                  with your vehicle’s service needs.
                </p>
                <p>
                  Our AAA Albemarle Car Care location at 5617 Albemarle Rd,
                  Charlotte, NC 28212,{' '}
                  <strong>will be moving as of March 19th, 2021.</strong>
                </p>
                <p>
                  With the news of this move, I wanted to give you peace of mind
                  that your customer records will not be affected. We will
                  retain all of the items below, and they will be available and
                  valid at any of our AAA Car Care Locations.
                </p>
                <BulletList>
                  <li>Warranty information on all parts and repair </li>
                  <li>Lifetime Protection Plan</li>
                  <li>Tire Warranty</li>
                  <li>Customer records </li>
                </BulletList>
                <p>
                  While our location will be changing, our commitment to you is
                  as strong as ever. It’s who we are and what you deserve.{' '}
                </p>
                <p>
                  Thank you again for being one of our customers, and we look
                  forward to continuing to serve you at AAA Car Care.{' '}
                </p>
                <p>Best Regards,</p>
                <img src="https://aaacdndev.blob.core.windows.net/wordpress/2021/02/Philander_Signature_Image.png"></img>
                <p>
                  <strong>Philander Harvey</strong>
                  <br /> AVP – AAA Car Care
                </p>
              </Col>

              <Col
                xs={{ span: 22, offset: 1 }}
                md={{ span: 8, offset: 2 }}
                lg={{ span: 6, offset: 2 }}
              >
                <CarCareLocationBox />
              </Col>
            </Row>

            <Row style={{ paddingTop: 48, backgroundColor: '#E9E9E9' }}>
              <Title style={{ margin: 'auto' }}>
                Exclusive Savings For Your Car Care Visit:
              </Title>
            </Row>
            <Row
              style={{ paddingTop: 48, backgroundColor: '#E9E9E9' }}
              gutter={[0, 32]}
            >
              <Col
                xl={{ span: '10', offset: '3' }}
                xs={{ span: '20', offset: '2' }}
              >
                <a href="https://carolinas.aaa.com/automotive/carcare/coupons/aaa-winter-maintenance-package-feb/">
                  <img
                    style={{ width: '90%' }}
                    src="https://aaacdndev.blob.core.windows.net/wordpress/2021/02/Winter_Package_Coupon.jpg"
                  />
                </a>
              </Col>
              <Col
                xl={{ span: '10', offset: '0' }}
                xs={{ span: '20', offset: '2' }}
              >
                <a href="https://carolinas.aaa.com/automotive/carcare/coupons/save-up-to-150-feb-2/">
                  <img
                    style={{ width: '90%' }}
                    src="https://aaacdndev.blob.core.windows.net/wordpress/2021/02/Save_Up_To_150_Coupon.jpg"
                  />
                </a>
              </Col>
            </Row>
            <Row style={{ backgroundColor: '#E9E9E9' }} gutter={[0, 32]}>
              <Col
                xl={{ span: '10', offset: '3' }}
                xs={{ span: '20', offset: '2' }}
              >
                <a href="https://carolinas.aaa.com/automotive/carcare/coupons/40-off-engine-cooling-system-service-feb/">
                  <img
                    style={{ width: '90%' }}
                    src="https://aaacdndev.blob.core.windows.net/wordpress/2021/02/40_Off_Coupon.jpg"
                  />
                </a>
              </Col>
              <Col
                xl={{ span: '10', offset: '0' }}
                xs={{ span: '20', offset: '2' }}
              >
                <a href="https://carolinas.aaa.com/automotive/carcare/coupons/alignment-check-feb/">
                  <img
                    style={{ width: '90%' }}
                    src="https://aaacdndev.blob.core.windows.net/wordpress/2021/02/Free_Alignment_Check_Coupon.jpg"
                  />
                </a>
              </Col>
            </Row>

            <Row
              style={{
                backgroundColor: '#E9E9E9',
                paddingBottom: '48',
              }}
              gutter={[0, 32]}
            >
              <Col
                xl={{ span: '10', offset: '3' }}
                xs={{ span: '20', offset: '2' }}
              >
                <a href="https://carolinas.aaa.com/automotive/carcare/coupons/free-tire-installation-with-4-tire-purchase-feb/">
                  <img
                    style={{ width: '90%' }}
                    src="https://aaacdndev.blob.core.windows.net/wordpress/2021/02/Free_Tire_Installation_Coupon.jpg"
                  />
                </a>
              </Col>
            </Row>
          </Layout>
        </AdsProvider>
      </SettingProvider>
    </ApolloProvider>
  );
};

export default AlbemarleLandingPage;
